 import useAuth from '../../hooks/useAuth';

const LogoutPage = () => {
  const {logout} = useAuth()
  logout();
  return null;
};

export default LogoutPage;
